export enum DesignMode {
  DESIGN_ROUTE = 'designRoute',
  VIEW = 'view'
}
